import { motion } from 'framer-motion'
import React, { ReactNode } from 'react'

type SlowRevealSpanProps = {
  className?: string
  children: ReactNode
}

export default function SlowRevealSpan({
  className,
  children,
}: SlowRevealSpanProps) {
  return (
    <motion.span
      variants={{
        start: { opacity: 0.4 },
        end: { opacity: 1.0 },
      }}
      transition={{ ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.span>
  )
}
